import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { withRouter } from 'react-router'
import { modal } from 'redux/modules/app'
import { Prompt } from 'react-router-dom'

function decorator(config = {}) {
  return ComposedComponent => {
    @withRouter
    @injectIntl
    @reduxForm({
      form: config.form,
      validate: config.validate,
      asyncValidate: config.asyncValidate,
      destroyOnUnmount: config.destroyOnUnmount === undefined || true
    })
    @connect(
      (state, props) => ({
        values:
          state.form[config.form || props.form] &&
          state.form[config.form || props.form].values,
        errors:
          state.form[config.form || props.form] &&
          state.form[config.form || props.form].syncErrors,
        modalObj: state.app.modal
      }),
      { modal, push }
    )
    class Form extends Component {
      static propTypes = {
        pristine: PropTypes.bool.isRequired,
        submitSucceeded: PropTypes.bool.isRequired,
        modalObj: PropTypes.object.isRequired,
        route: PropTypes.object,
        modal: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        initialize: PropTypes.func.isRequired
      }

      componentDidMount() {
        this.handleFormInitialize(this.handleGetInitialProps(this.props))
      }

      componentWillReceiveProps = nextProps => {
        if (
          get(this.props, config.initialProps) !==
          get(nextProps, config.initialProps)
        ) {
          this.handleFormInitialize(this.handleGetInitialProps(nextProps))
        }
      }

      key = uuid.v1()

      handleFormInitialize = data => {
        config.initialProps && this.props.initialize(data)
      }

      handleGetInitialProps = props =>
        config.initialPropsMapper
          ? config.initialPropsMapper(get(props, config.initialProps))
          : get(props, config.initialProps)


      handlePromptClosing = nextLoc => {
        const { pristine, submitSucceeded } = this.props

        const { route } = this.props

        if (!route) {
          // console.warn('Route is not specified. Provide route prop or set disableHook:true')
          return
        }

        if (config.disableHook)
          return false

        if (submitSucceeded || pristine) {
          return false
        }

        if (!pristine && nextLoc.state && nextLoc.state.shouldRedirect) {
          // console.debug('Next location ...', nextLoc)
          return false
        }

        return true
      }


      handleRedirect = () =>
        this.props.push({
          pathname: this.props.modalObj.next,
          state: { shouldRedirect: true }
        })

      handleSubmitCustom = submitHandler => {
        return e => {
          if (!config.enablePropagation) {
            e.stopPropagation()
          }

          return this.props.handleSubmit(submitHandler)(e)
        }
      }

      render() {
        const { intl } = this.props

        return (
          <div>
            <ComposedComponent {...this.props}
               handleSubmit={this.handleSubmitCustom}
            />
            {!config.disableHook && (
              <Prompt
                message={nextLoc =>
                  this.handlePromptClosing(nextLoc)
                    ? intl.formatMessage({
                      defaultMessage:
                        "Your changes haven't been saved. Data will be lost.",
                      id: 'label.your_changes_havent_been_saved'
                    })
                    : true
                }
              />
            )}
          </div>
        )
      }
    }
    return Form
  }
}

export default decorator
